// service
import AxiosInstanceCreator from 'services/api';

// models
import type { BaseApiResponse } from 'modules';
import type { ReqSystemSafety } from '../models/system-safety.model';
import type { ReqSystemSave, ReqSystemUpdate, SystemCode } from '../models/system.model';

// libraries
import { type AxiosInstance } from 'axios';

export class SystemSafetyAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator({}).create();
  }

  /** 안전교육 시스템 세팅 조회 API */
  async getSystemList(params: ReqSystemSafety): Promise<BaseApiResponse<unknown, SystemCode>> {
    return await this.Axios.get<BaseApiResponse<unknown, SystemCode>>('/system/safety', {
      params
    }).then((res) => res.data);
  }

  /** 안전교육 시스템 코드 추가 API */
  async saveSystemCode(params: ReqSystemSave): Promise<BaseApiResponse<SystemCode>> {
    return await this.Axios.post<BaseApiResponse<SystemCode>>('/system/safety', params).then(
      (res) => res.data
    );
  }

  /** 안전교육 시스템 코드 업데이트 API */
  async updateSystemCode(params: ReqSystemUpdate): Promise<BaseApiResponse<SystemCode>> {
    return await this.Axios.post<BaseApiResponse<SystemCode>>('/system/safety/modify', params).then(
      (res) => res.data
    );
  }

  /** 안전교육 시스템 세팅 범위 조회 API */
  async getSystemListByRange(params: {
    clsCdStart?: number;
    clsCdLast?: number;
  }): Promise<BaseApiResponse<unknown, SystemCode>> {
    return await this.Axios.get<BaseApiResponse<unknown, SystemCode>>('/system/safety/list', {
      params
    }).then((res) => res.data);
  }

  /** 안전교육 시스템 세팅 삭제 API */
  async deleteSystemCode(systemId: string): Promise<BaseApiResponse<string>> {
    return await this.Axios.delete<BaseApiResponse<string>>(`/system/safety/${systemId}`).then(
      (res) => res.data
    );
  }
}
